package team.platforma.chat_presentation.model

data class DraftPresentation (
    val draftId: Long,
    val aiModelId: Long,
    val userId: Long,
    val chatId: Long,
    val text: String
)